<section *ngIf="!isLoading && cmsData">
    <div class="page-title">
        <h2>{{ pageTitle }}</h2>
    </div>
    <div class="order-summary-section">
        <xm-order-summary [cmsData]="cmsData">
        </xm-order-summary>
    </div>
    <xm-whats-changing-component *ngIf="cmsData.orderSummary?.summaries?.whatsChanging" [pageData]="cmsData.orderSummary?.summaries?.whatsChanging"></xm-whats-changing-component>
    <xm-estimated-next-bill [expandIconOptions]="expandIconOptions"
        *ngIf="cmsData.orderSummary?.summaries?.estimatedNextBill" [cmsData]="cmsData"></xm-estimated-next-bill>
    <xm-estimated-monthly-bill [expandIconOptions]="expandIconOptions"
        *ngIf="cmsData.orderSummary?.summaries?.estimatedMonthlyBill" [cmsData]="cmsData"></xm-estimated-monthly-bill>
    <div class="content">
        <div class="action">
            <button class="xm-btn-link-light left-btn" (click)="onBack()">{{ backBtn }}</button>
            <button class="xm-btn-primary-light" (click)="startUpgrade()">{{ upgradeBtn }}</button>
        </div>
    </div>
</section>
<section *ngIf="isLoading">
    <xm-loader-overlay [type]="'order-summary'"></xm-loader-overlay>
    <xm-loader-overlay [type]="'billPreview-WhatsChanging'"></xm-loader-overlay>
    <xm-loader-overlay [type]="'billPreview-WhatsChanging'"></xm-loader-overlay>
    <xm-loader-overlay [type]="'billPreview-WhatsChanging'"></xm-loader-overlay>
</section>

